import {
  useMutation,
  UseMutationResult,
  useQuery,
} from "@tanstack/react-query";
import { courses } from "../products/courses";
import {
  ClassesGetByIdInterface,
  CourseClassByIdInterface,
  CourseClassInterface,
  coursesCreateInterface,
  coursesDataInterface,
  DeleteParams,
  UserCourseDataInterface,
} from "../types/types";

export function useCourses(): UseMutationResult<
  any,
  unknown,
  coursesCreateInterface,
  unknown
> {
  return useMutation({
    mutationFn: (body: coursesCreateInterface) => courses.CreateCourses(body),
  });
}
export function useCourseClass(
  courseId: number
): UseMutationResult<any, unknown, CourseClassInterface, unknown> {
  return useMutation({
    mutationFn: (body: CourseClassInterface) =>
      courses.CreateCoursesClass(body, courseId),
  });
}

export function useGetCourse(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<coursesDataInterface>({
      queryKey: ["getCourseData"],
      queryFn: () => courses.GetCourseData(option),
    });

  return {
    courseData: data,
    courseLoading: isLoading,
    error,
    status,
    isSuccess,
    courseRefetch: refetch,
  };
}
export function useGetUserCourse(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<UserCourseDataInterface>({
      queryKey: ["getUserCourseData"],
      queryFn: () => courses.GetUserCourseData(option),
    });

  return {
    courseData: data,
    courseLoading: isLoading,
    error,
    status,
    isSuccess,
    courseRefetch: refetch,
  };
}
export function useGetCourseById(id?: number) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<ClassesGetByIdInterface>({
      queryKey: ["getClassesGetById"],
      queryFn: () => courses.GetCourseById(id),
      enabled: !!id,
    });

  return {
    CourseData: data,
    CourseLoading: isLoading,
    error,
    status,
    isSuccess,
    CourseRefetch: refetch,
  };
}
export function useGetCourseClassById(option?: any) {
  const { data, isLoading, error, status, isSuccess, refetch } =
    useQuery<CourseClassByIdInterface>({
      queryKey: ["getCourseClassById"],
      queryFn: () => courses.GetCourseClassById(option),
      // enabled: false,
    });

  return {
    CourseClassData: data,
    CourseClassLoading: isLoading,
    error,
    status,
    isSuccess,
    CourseClassRefetch: refetch,
  };
}
export function useUpdateCourse(
  id: number
): UseMutationResult<any, unknown, coursesCreateInterface, unknown> {
  return useMutation({
    mutationFn: (body: coursesCreateInterface) =>
      courses.UpdateCourse(body, id),
  });
}

export function useUpdateCourseClass(
  id: number
): UseMutationResult<any, unknown, any, unknown> {
  return useMutation({
    mutationFn: (body: any) => courses.UpdateCourseClass(body, id),
  });
}
export function useDeleteCourses(): UseMutationResult<
  any,
  unknown,
  DeleteParams,
  unknown
> {
  return useMutation({
    mutationFn: (body: DeleteParams) => courses.deleteCourses(body.id),
  });
}
export function useDeleteCoursesClass(): UseMutationResult<
  any,
  unknown,
  DeleteParams,
  unknown
> {
  return useMutation({
    mutationFn: (body: DeleteParams) => courses.deleteCoursesClass(body.id),
  });
}
